// store/profileSlice.ts
import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { getProfile } from '../../api/ApiUser';
import { ProfileResponse } from '../../api/ApiResponse';

export const fetchProfile = createAsyncThunk<
  ProfileResponse,
  string,
  { rejectValue: string }
>(
  'profile/fetchProfile',
  async (walletAddress, thunkAPI) => {
    if (!walletAddress) {
        console.log('No wallet address');
      return thunkAPI.rejectWithValue('No wallet address');
    }
    try {
      const response = await getProfile({ walletAddress });
      if (response.payload) return response.payload;
      return thunkAPI.rejectWithValue(response.error || 'Unknown error');
    } catch {
      return thunkAPI.rejectWithValue('Network error');
    }
  }
);

interface ProfileState {
    data: ProfileResponse | null;
    loading: boolean;
    error: string | null;
}
const initialState: ProfileState = {
    data: null,
    loading: false,
    error: null,
};

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        clearProfile(state) {
            state.data = null;
            state.error = null;
            state.loading = false;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchProfile.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProfile.fulfilled, (state, action: PayloadAction<ProfileResponse>) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(fetchProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    }
});

export const { clearProfile } = profileSlice.actions;
export default profileSlice.reducer;